module.exports = __webpack_public_path__ + "resources/img/img_watchall_lms2_en.c45e3489bd819a6c0a3d902923a0e7a3.png";